(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[76791],{

/***/ 78583:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/testingapp",
      function () {
        return __webpack_require__(99611);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _layouts_DocumentationLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53339);
/* harmony import */ var _layouts_ContentsLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33481);
/* harmony import */ var _components_Tip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55390);
/* harmony import */ var _components_CodeSample__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72308);



/* @jsxRuntime classic */ /* @jsx mdx */ 






var Layout = _layouts_DocumentationLayout__WEBPACK_IMPORTED_MODULE_4__/* .DocumentationLayout */ .L;
var meta = {
    "id": "testingapp",
    "title": "Test Apps",
    "sidebar_label": "Testing App"
};
var slug = "testingapp";
var tableOfContents = [
    {
        "title": "PRODUCTION:",
        "slug": "production",
        "children": [
            {
                "title": "Using Your Android App",
                "slug": "using-your-android-app",
                "children": []
            },
            {
                "title": "Using/Accessing Your iOS App",
                "slug": "using-accessing-your-i-os-app",
                "children": []
            }
        ]
    },
    {
        "title": "Requirements for testing",
        "slug": "requirements-for-testing",
        "children": []
    },
    {
        "title": "Important Note:",
        "slug": "important-note",
        "children": []
    },
    {
        "title": "Things that are not testable",
        "slug": "things-that-are-not-testable",
        "children": []
    },
    {
        "title": "SANDBOX:",
        "slug": "sandbox",
        "children": []
    }
];
var layoutProps = {
    Layout: Layout,
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = _layouts_ContentsLayout__WEBPACK_IMPORTED_MODULE_5__/* .ContentsLayout */ .X_;
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, " Testing the app has two different methods based on the stage you are "), "\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "production",
        nextElement: {
            "type": "paragraph"
        }
    }, "PRODUCTION:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "This is a live mode. You can use the preview domain under tradly.co for you to see your website. or add your ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/settings/domain",
        passHref: true
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", null, "custom domain")), ". Suitable for those seeking a straightforward and quick launch approach."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "using-your-android-app",
        nextElement: {
            "type": "jsx"
        }
    }, "Using Your Android App"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/googleplay.svg",
        alt: "signup-page",
        width: "200"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Download Link: \xa0", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://play.google.com/store/apps/details?id=tradly.platform"
    }), "Tradly Platform Android")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can download the app using the above link on your android device and enter your tenant ID (also called as appname or project) app name. \xa0")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "using-accessing-your-i-os-app",
        nextElement: {
            "type": "jsx"
        }
    }, "Using/Accessing Your iOS App"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/appstore.svg",
        alt: "signup-page",
        width: "200"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Download Link: \xa0", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://apps.apple.com/app/id1524190804"
    }), "Tradly Platform iOS")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You can download the app using the above link on your iOS device and enter your tenant ID or app name.\xa0")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "requirements-for-testing",
        nextElement: {
            "type": "list",
            "ordered": true,
            "start": 1,
            "spread": false
        }
    }, "Requirements for testing"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "SuperAdmin account."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Download an Android App OR"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Download an iOS app OR")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "4.", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://github.com/TRADLY-PLATFORM/"
    }), "Fork open-source apps here")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "important-note",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Important Note:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "In order to submit a listing, you must first register as a user. So, it’s a 2-level stage. Not all users would need it, but a seller would need it.\xa0\n-When there are no categories created in the SuperAdmin panel, you will find the homepage empty as well. And you can’t view listings, as you need to navigate through categories.\xa0\n-When there are no accounts(called “stores” in the fashion marketplace) and your marketplace is new, you will not find widgets(follow store/accounts) on the home page. Also, you cannot follow stores. Hence, the social feed will be empty.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "When there are no promotions created in your SuperAdmin panel, you will not find them on the app home page. So, again, it will feel empty.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Your searches will not work if there are no listings.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "You cannot use the chat function if there are no listings, as chats are initiated through listings\xa0")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Hence, spend time registering dummy users, opening accounts/stores, submitting listings, etc. If you want to skip all the steps, you can simply use ‘tradlysocial’ as a tenant without superadmin access and experience the front-end app.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "things-that-are-not-testable",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Things that are not testable"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "3rd party tool settings, such as branch and firebase, as these require app build changes. And you will get it when we provide white label app building.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "App Icons\xa0")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "sandbox",
        nextElement: {
            "type": "paragraph"
        }
    }, "SANDBOX:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "The Sandbox mode mobile app has been decommissioned as of July 20, 2022. Sandbox apps are moved to production apps. The Sandbox superadmin has been decommissioned as of Nov 23, 2022.\xa0"));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 72308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports CodeSample, ResizableCodeSample */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53280);






var codeBackground = {
    amber: "bg-amber-500",
    emerald: "bg-emerald-500",
    fuchsia: "bg-fuchsia-400",
    indigo: "bg-indigo-400",
    lightBlue: "bg-light-blue-500",
    purple: "bg-purple-400",
    rose: "bg-rose-400"
};
var previewBackground = {
    amber: "bg-gradient-to-r from-amber-50 to-amber-100",
    emerald: "bg-gradient-to-r from-emerald-50 to-teal-100",
    fuchsia: "bg-gradient-to-r from-fuchsia-50 to-fuchsia-100",
    gray: "bg-gradient-to-r from-gray-50 to-gray-100",
    indigo: "bg-gradient-to-r from-indigo-50 to-indigo-100",
    lightBlue: "bg-gradient-to-r from-light-blue-50 to-light-blue-100",
    purple: "bg-gradient-to-r from-purple-50 to-purple-100",
    rose: "bg-gradient-to-r from-rose-50 to-rose-100"
};
var containerBackground = {
    amber: "bg-stripes bg-stripes-amber-500 bg-amber-100",
    emerald: "bg-stripes bg-stripes-emerald-500 bg-emerald-100",
    fuchsia: "bg-stripes bg-stripes-fuchsia-500 bg-fuchsia-100",
    indigo: "bg-stripes bg-stripes-indigo-500 bg-indigo-100",
    lightBlue: "bg-stripes bg-stripes-light-blue-500 bg-light-blue-100",
    purple: "bg-stripes bg-stripes-purple-500 bg-purple-100",
    rose: "bg-stripes bg-stripes-rose-500 bg-rose-100"
};
var handle = {
    amber: "text-amber-700",
    emerald: "text-emerald-700",
    fuchsia: "text-fuchsia-700",
    indigo: "text-indigo-700",
    lightBlue: "text-light-blue-700",
    purple: "text-purple-700",
    rose: "text-rose-700"
};
function Frame(props) {
    var ref = useRef();
    var ref1 = useState(false), frameLoaded = ref1[0], setFrameLoaded = ref1[1];
    var ref2 = useState({}), style = ref2[0], setStyle = ref2[1];
    useEffect(function() {
        var updateStyle = function updateStyle() {
            setStyle({
                height: ref.current.contentDocument.body.scrollHeight
            });
        };
        if (!frameLoaded) return;
        var observer = new window.ResizeObserver(updateStyle);
        updateStyle();
        observer.observe(ref.current.contentDocument.body);
        return function() {
            observer.disconnect();
        };
    }, [
        frameLoaded
    ]);
    return /*#__PURE__*/ _jsx("iframe", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        onLoad: function() {
            return setFrameLoaded(true);
        },
        style: style
    }));
}
function Snippet(param) {
    var color = param.color, snippet = param.snippet;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx("overflow-hidden rounded-b-xl", codeBackground[color], {
            "bg-gray-800": !codeBackground[color]
        }),
        children: /*#__PURE__*/ _jsx("pre", {
            className: clsx("scrollbar-none overflow-x-auto p-6 text-sm leading-snug language-html text-gray-50", {
                "bg-black bg-opacity-75": codeBackground[color]
            }),
            children: /*#__PURE__*/ _jsx("code", {
                className: "language-html",
                dangerouslySetInnerHTML: {
                    __html: snippet
                }
            })
        })
    });
}
function CodeSample(param) {
    var preview = param.preview, src = param.src, snippet = param.snippet, previewClassName = param.previewClassName, _color = param.color, color = _color === void 0 ? "gray" : _color;
    return /*#__PURE__*/ _jsxs("div", {
        className: "not-prose relative overflow-hidden mb-8",
        children: [
            preview ? /*#__PURE__*/ _jsx("div", {
                className: clsx("rounded-t-xl overflow-hidden", previewBackground[color], previewClassName, {
                    "p-10": !previewClassName
                }),
                dangerouslySetInnerHTML: {
                    __html: preview
                }
            }) : /*#__PURE__*/ _jsx(Frame, {
                src: src,
                className: clsx("w-full rounded-t-xl", previewBackground[color])
            }),
            /*#__PURE__*/ _jsx(Snippet, {
                color: color,
                snippet: snippet
            })
        ]
    });
}
function ResizableCodeSample(param) {
    var preview = param.preview, src = param.src, previewClassName = param.previewClassName, snippet = param.snippet, _color = param.color, color = _color === void 0 ? "gray" : _color, _min = param.min, min = _min === void 0 ? false : _min;
    var previewContainerRef = useRef();
    var x = useMotionValue(0);
    var constraintsRef = useRef();
    var ref = useState(false), dragging = ref[0], setDragging = ref[1];
    useEffect(function() {
        var observer = new window.ResizeObserver(function() {
            x.set(0);
        });
        observer.observe(previewContainerRef.current);
        return function() {
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: "not-prose relative mb-8",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                ref: previewContainerRef,
                className: "relative rounded-t-xl ".concat(containerBackground[color]),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: min ? "md:w-88" : undefined,
                        children: /*#__PURE__*/ _jsx(motion.div, {
                            className: "relative",
                            style: {
                                marginRight: useTransform(x, function(x) {
                                    return -x;
                                })
                            },
                            children: preview ? /*#__PURE__*/ _jsx("div", {
                                className: clsx("rounded-t-xl", previewClassName, previewBackground[color], {
                                    "p-10": !previewClassName
                                }),
                                dangerouslySetInnerHTML: {
                                    __html: preview
                                }
                            }) : /*#__PURE__*/ _jsx(Frame, {
                                src: src,
                                className: clsx("w-full rounded-t-xl", previewBackground[color], {
                                    "pointer-events-none": dragging
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        ref: constraintsRef,
                        className: "absolute inset-y-0 -right-4 left-80 ml-4 pointer-events-none",
                        children: /*#__PURE__*/ _jsx(motion.div, {
                            drag: "x",
                            _dragX: x,
                            dragMomentum: false,
                            dragElastic: 0,
                            dragConstraints: constraintsRef,
                            className: "pointer-events-auto absolute top-1/2 -mt-4 w-8 hidden md:flex items-center justify-center cursor-grab active:cursor-grabbing ".concat(min ? "right-0 md:left-0 md:right-auto" : "right-0"),
                            style: {
                                x: x
                            },
                            onDragStart: function() {
                                document.body.classList.add("cursor-grabbing");
                                setDragging(true);
                            },
                            onDragEnd: function() {
                                document.body.classList.remove("cursor-grabbing");
                                setDragging(false);
                            },
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "flex-none rounded bg-white shadow flex items-center justify-center h-8",
                                style: {
                                    width: "0.9375rem"
                                },
                                children: /*#__PURE__*/ _jsx("svg", {
                                    viewBox: "0 0 14 24",
                                    fill: "none",
                                    strokeWidth: "2",
                                    stroke: "currentColor",
                                    className: "h-3 flex-none ".concat(handle[color]),
                                    style: {
                                        width: "0.4375rem"
                                    },
                                    children: /*#__PURE__*/ _jsx("path", {
                                        d: "M 1 0 V 24 M 7 0 V 24 M 13 0 V 24"
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Snippet, {
                color: color,
                snippet: snippet
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [43430,61699,85220,96401,94965,48777,26852,5679,63432,49774,92888,40179], function() { return __webpack_exec__(78583); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);